/**
 * @flow
 * @author: Chinmaya
 */

import * as React from 'react'

type Props = {}

class CloseIcon extends React.Component<Props> {
  render() {
    const { width, height, fillColor, className } = this.props
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14 14"
        className={className}
      >
        <g fill="none" fill-rule="evenodd">
          <path
            fill={fillColor}
            d="M14 1.4L12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4l5.6 5.6 1.4-1.4L8.4 7z"
          />
          <path d="M-5-5h24v24H-5z" />
        </g>
      </svg>
    )
  }
}

CloseIcon.defaultProps = {
  width: 14,
  height: 14,
  fillColor: 'rgb(67, 72, 76)'
}

export default CloseIcon
